export default __webpack_public_path__ + "static/media/icon_profile.d461880a.svg";